<template>
  <div class="vue__requested-payment">
    <FaLayers v-if="payment.paid" class="fa-3x">
      <FaIcon :icon="['far', 'credit-card']" />
      <FaIcon icon="check" transform="shrink-4 right-7" />
    </FaLayers>
    <FaIcon v-else :icon="['far', 'credit-card']" size="3x" />

    <h4>
      <template v-if="!payment.paid">
        Оплата участия
      </template>
      <template v-else>
        Благодарим за оплату
      </template>
    </h4>

    <p v-if="!payment.paid">
      Вам был составлен счёт на сумму
    </p>
    <p class="vue__requested-payment-amount">{{payment.amount}}&euro;</p>
    <p class="vue__requested-payment-status">
      <template v-if="payment.paid">
        оплачено
        <span class="text-nowrap">{{payment.paidAt}}</span>
      </template>
      <template v-else>
        к оплате
        <span class="text-nowrap">до {{payment.dueOn}}</span>
      </template>
    </p>

    <div class="vue__payment-type" v-if="!payment.paid">
      <p>Выберите способ оплаты:</p>

      <label for="payment_online">
        <input type="radio" id="payment_online" name="payment_type" value="online" v-model="paymentType">
        Картой / PayPal
      </label>

      <label for="payment_bank">
        <input type="radio" id="payment_bank" name="payment_type" value="bank" v-model="paymentType">
        Банковский перевод
      </label>

      <div class="vue__payment-type-content">
        <transition name="fade-slide" mode="out-in">
          <div key="online" v-if="paymentType === 'online'">
            <BaseButton tag="a" :href="payment.url">
              К оплате
              <FaIcon icon="arrow-right" class="fa-fw" />
            </BaseButton>
          </div>
          <div key="bank" v-else>
            <BankDetails :agreement-number="payment.agreementNumber" />
          </div>
        </transition>
      </div>
    </div>
    <div v-else>
      <BaseButton tag="a" href="/">
        <FaIcon icon="arrow-left" class="fa-fw" />
        На главную
      </BaseButton>
    </div>

  </div>
</template>

<script>
  import BankDetails from './BankDetails';

  import { mapState } from 'vuex';

  export default {
    components: {
      BankDetails
    },

    computed: {
      ...mapState([
        'payment'
      ])
    },

    data() {
      return {
        paymentType: 'online'
      }
    }
  };
</script>

<style lang="scss" scoped>
  .vue__requested-payment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .fa-credit-card path {
      fill: royalblue;
    }

    .fa-check path {
      fill: limegreen;
    }

    h4 {
      margin-top: 10px;
      font-weight: 400;
      font-size: 20px;
    }

    p {
      font-size: 17px;
    }

    .vue__requested-payment-amount {
      font-size: 24px;
      margin-bottom: 4px;
    }

    .vue__requested-payment-status {
      font-size: 14px;
      color: #888;
    }

    .vue__payment-type {
      label {
        font-weight: 400;
      }

      .vue__payment-type-content {
        margin-top: 16px;
      }
    }
  }
</style>